import { useCallback } from 'react';

import { useStores } from 'stores/rootStore';

export default function useCloseModal() {
  const { pageStore } = useStores();
  const closeModal = useCallback(() => {
    pageStore.closeModal();
  }, [pageStore]);

  return closeModal;
}
